import React, { memo } from 'react';
import { Tooltip } from 'antd';
import { ApprovalWorkflowItemDto, AWStageDto } from '@api/Api';
import Status from '@components/Approval/Status';

import CampaignApprovalAction from '@pages/Campaigns/CampaignApproval/components/CampaignApprovalAction';
import CampaignApprovalActionMenu from '@pages/Campaigns/CampaignApproval/components/CampaignApprovalActionMenu';

import './CampaignApprovalHead.less';

type CampaignApprovalHeadProps = {
  approvalWorkflow: ApprovalWorkflowItemDto;
  currentStage: AWStageDto | null;
  refetchApprovalWorkflow: () => void;
};

export default memo(function CampaignApprovalHead({
  approvalWorkflow,
  currentStage,
  refetchApprovalWorkflow
}: CampaignApprovalHeadProps) {
  return (
    <div className="campaign-approval_head">
      <div className="campaign-approval_head-info">
        <Tooltip
          title={approvalWorkflow.name}
          overlayClassName="toggle_favorite_overlay"
          className="b-asset-name"
          placement="topLeft"
        >
          <div className="campaign-approval_head-name">
            {approvalWorkflow.name}
          </div>
        </Tooltip>
        <Status
          isCurrentStage={currentStage?.id === approvalWorkflow.currentStageId}
          status={currentStage?.status || approvalWorkflow.status}
          approvalWorkflowStatus={approvalWorkflow.status}
          approvalWorkflowIsPaused={approvalWorkflow.isPaused}
          deadline={currentStage?.deadline || null}
        />
        <CampaignApprovalActionMenu approvalWorkflow={approvalWorkflow} />
      </div>
      {approvalWorkflow.permissions.manage && (
        <CampaignApprovalAction
          approvalWorkflow={approvalWorkflow}
          currentStage={currentStage}
          refetchApprovalWorkflow={refetchApprovalWorkflow}
        />
      )}
    </div>
  );
});
